import { render } from "./YouTubeVideo.vue?vue&type=template&id=744cee2d&scoped=true"
import script from "./YouTubeVideo.vue?vue&type=script&lang=js"
export * from "./YouTubeVideo.vue?vue&type=script&lang=js"

import "./YouTubeVideo.vue?vue&type=style&index=0&id=744cee2d&scoped=true&lang=css"

import exportComponent from "C:\\Users\\PR024\\Desktop\\uzcsd-uz\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-744cee2d"]])

export default __exports__